export default __webpack_public_path__ + "static/media/hht1_song_13.f54000e8.png";